export const lang = {
    header_index: 'Home',
    header_about: 'About',
    header_project: 'Investment Portfolio',
    header_friend: 'Strategic partner',
    header_people: 'Human resources service',
    header_news: 'News',
    header_memo: 'Overview',
    header_lang: '中文',

    //底部
    foot_Phone: 'Phone：021-55785999',
    foot_Mailbox: 'Mailbox：info@modern-cap.com',
    foot_Address: 'Address：S09, 16th Floor, Juyang Tower, 1200 Pudong Ave, Shanghai',

    //主页
    index_Company_wx: 'WeChart',
    index_Company_Profile: 'Company Profile',
    index_Company_Profile_text: "Founded in 2016, Modern Capital is a company focused on mobile Internet+, cross-border entertainment/consumption and smart hardware/IoT. We are the leader in the investment of new communication and marketing channels such as WeChat. More than 10 projects invested by Modern Capital were subsequently invested by other famous investment institutions. We signed a strategic cooperation agreement with Tencent and were awarded the “Excellent Investment Partner” by Tencent in 2017 and 2018. With our international vision and rich cross-border trading experience, we have invested seven projects in Korea, becoming the most successful Chinese investment team in Korea. We have also set up an office to launch cross-border consumption M&A business in Japan.",

    //人力资源页面
    people_title: 'Human resources service',
    people_text: '             Modern Capital invests in the combination of top Internet venture capital and traditional high-end headhunting, and 360-degree talent strategic cooperation with leading entrepreneurial teams. Services include: high-end talent recruitment, corporate organizational design, options and other incentive design, social security personnel consulting and project services.',

    //创始人寄语
    ceo_info_name: 'Xu Jie',
    ceo_info_nick: 'Founder/Chief waiter',
    ceo_info_title: 'Modern Capital invests in entrepreneurs around entrepreneurs',
    ceo_info_text1: "It is venture investor's due responsibility to ascend to the basis of study and research and to support entrepreneurs to make innovations through trial and error. It is our main goal to grasp the updates in consumer demand and the way in which demand is implemented and to participate in the great changes related to these updates.",
    ceo_info_text2: 'Our team has achieved amazing investments and exits in the past decade and has gained some returns. But it is more important for us to gain a lot of experience and lessons. Looking forward to the future, we will put more emphasis on the integration of research and overall resources and will focus on the business layout of consumption and achieve better results.',
    ceo_info_text3: 'We are the leader in the field of investment return in broad consumption section, especially in WeChat, the representative of new channel.',
    ceo_info_text4: 'We are skilled in transnational investment and M&A, especially in the area of consumption and culture. Health services and biopharmaceuticals are areas we are not that good at, but we have the confidence to catch up in the long run.',

    //投资项目
    project_info_title: 'Investment Portfolio',
    project_info_btn1: 'Domestic',
    project_info_btn2: 'Oversea',

    //合作
    fried_one: "Strategic Partners",
    fried_two: 'Investors'
}